import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSite } from "@/contexts/SiteContext";
import api from "@/lib/api";

const STORAGE_KEY = "ct_cookie_consent_v1";

export default function CookieBanner() {
  const { site } = useSite();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored && site?.gdpr?.show_banner !== false) setVisible(true);
  }, [site]);

  const decide = async (accepted) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted, ts: Date.now() }));
    setVisible(false);
    try {
      await api.post("/public/cookies-consent", { accepted, categories: { essential: true, analytics: accepted } });
    } catch (e) {
      // best-effort logging only
    }
  };

  if (!visible) return null;
  const text = site?.gdpr?.cookie_banner_text || "Folosim cookies pentru a îmbunătăți experiența ta pe site.";

  return (
    <div
      data-testid="cookie-banner"
      role="region"
      aria-label="Consimțământ cookies"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-40 p-5 rounded-[4px] border backdrop-blur-xl"
      style={{ background: "rgba(13,27,42,0.96)", borderColor: "var(--ct-border-gold)" }}
    >
      <p className="text-sm leading-relaxed" style={{ color: "#C8CDD2" }}>
        {text}{" "}
        <Link to="/politica-cookies" className="underline" style={{ color: "var(--ct-gold)" }}>
          Detalii
        </Link>
      </p>
      <div className="mt-4 flex gap-2">
        <button data-testid="cookie-accept" onClick={() => decide(true)} className="btn-gold !py-2 !px-4 text-sm">
          Accept
        </button>
        <button data-testid="cookie-reject" onClick={() => decide(false)} className="btn-outline-gold !py-2 !px-4 text-sm" style={{ color: "#F7F5F0" }}>
          Doar esențiale
        </button>
      </div>
    </div>
  );
}
